/*  global googletag */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ConsentCookie from 'scripts/lib/ConsentCookie'
import ClientErrors from 'scripts/lib/ClientErrors'
import {isMobile, isClient} from 'scripts/lib/utils'
import NavigationObserver from 'scripts/lib/NavigationObserver'

const AdSlot = (props) => {
  if (isClient() && props) {
    const {id, width, height} = props
    const style = {
      height: `${height}px`,
      width: `${width}px`
    }

    const adId = `div-gpt-ad-${id}`
    return <div id={adId} className="inner-ad" style={style}></div>
  }
  return null
}

class Ad extends Component {
  adSlot = null
  networId = '50449293'
  slotPrefix = 'Soompi.v2'
  navObsever = null
  isDisplayed = (target) => {
    return isClient() &&
      document.getElementById(target) &&
      (document.getElementById(target).innerHTML !== '')
  }

  // Catch error on ad component to prevent spamming of third party errors on honeybadger from SoompiApp
  componentDidCatch(error, info) {
    console.log(error, info)
  }

  mobileAwareProps = () => {
    if (isMobile()) {
      return this.props.mobile
    } else {
      return this.props.desktop
    }
  }

  display = (target) => {
    if (isClient() && !this.isDisplayed(target)) {
      try {
        googletag.cmd.push(function() {
          googletag.display(target)
          googletag.pubads().refresh()
        })
      } catch (e) {
        ClientErrors({
          message: 'Ad failed to display',
          error: e
        })
      }
    }
  }

  writeScript = () => {
    var id = 'gpt-script'
    if (!document.getElementById(id)) { // check if we don't have it yet
      var head = document.getElementsByTagName('head')[0]
      var script = document.createElement('script')
      script.id = id
      script.type = 'text/javascript'
      script.innerHTML = `var script = document.createElement('script');
        var googletag = googletag || {};
        googletag.cmd = googletag.cmd || [];
        `
      head.appendChild(script)
    }
  }

  destroyAds = () => {
    if (!this.adSlot) { return null }
    try {
      const takeovers = document.getElementsByClassName('takeovers')
      const body = document.body

      googletag.pubads().clear([this.adSlot])
      googletag.destroySlots([this.adSlot])

      Array.from(takeovers).forEach(item => {
        item.parentNode.removeChild(item)
      })

      if (body.classList.contains('takeover')) {
        body.classList.remove('takeover')
        body.setAttribute('style', '')
        this.navObsever && this.navObsever.destroy()
        this.navObsever = null
      }
      delete window.doNavigationObserver
    } catch (e) {
      ClientErrors({
        message: 'Ad failed to destroy unit',
        error: e
      })
    }
  }

  defineSlot = (props) => {
    const {id, slot, width, height} = props
    const adId = `div-gpt-ad-${id}`
    if (this.props.outofpage) {
      return googletag.defineOutOfPageSlot(`/${this.networId}/${this.slotPrefix}.${slot}`, adId)
    }
    return googletag.defineSlot(`/${this.networId}/${this.slotPrefix}.${slot}`, [width, height], adId)
  }

  componentDidMount() {
    let localProps = this.mobileAwareProps()
    if (isClient() && localProps) {
      const {id} = localProps
      const adId = `div-gpt-ad-${id}`
      const consent = new ConsentCookie()
      // initiate gpt script
      this.writeScript()
      try {
        // define and display the ad
        googletag.cmd.push(() => {
          this.adSlot = this.defineSlot(localProps)
          this.adSlot.setCollapseEmptyDiv(true)
            .addService(googletag.pubads())
          googletag.pubads().enableSingleRequest()
          // Cookie consent toggle for personalized ads
          if (!consent.hasConsent('advertising')) {
            googletag.pubads().setRequestNonPersonalizedAds(1)
          }
          googletag.enableServices()
          googletag.display(adId)
        })

        if (this.props.outofpage) {
          window.doNavigationObserver = () => {
            this.navObsever = new NavigationObserver('navbar')
          }
        }
      } catch (e) {
        ClientErrors({
          message: 'Ad failed to initialize',
          error: e
        })
      }
    }
  }

  componentWillUnmount() {
    this.destroyAds()
  }

  render() {
    const { className } = this.props
    let localProps = this.mobileAwareProps()
    return (
      <div className={`ad ${className || ''}`}>
        {AdSlot(localProps)}
      </div>
    )
  }
}

export default Ad

Ad.propTypes = {
  desktop: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slot: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  }),
  mobile: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slot: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/ad.jsx